import {createSelector} from '@reduxjs/toolkit'
// eslint-disable-next-line no-restricted-imports
import {getIsIsraeliResident} from 'modules/meta/selectors'
import {RootState} from 'store'
import {urlParams} from 'utils/urlParams'

import {searchApi} from '@vio/core/src/sapi/services/searchApi'
import {getHasILResidentVAT} from '@vio/shared/src/utils/PriceInformations/vat'

const getHotelIdParam = (_: unknown, hotelId: string) => hotelId

const getHotelSelector = createSelector([getHotelIdParam], (hotelId: string) =>
  searchApi.endpoints.getHotel.select({hotelId})
)

const getHotelResult = (state: RootState) => {
  const {hotelId} = urlParams()
  if (!hotelId) return null
  const hotelSelector = getHotelSelector(state, hotelId)
  // Access the RTK Query cache for the getHotel endpoint
  return hotelSelector(state)
}
export const getHotelData = createSelector(
  [getHotelResult],
  hotelResult => hotelResult?.data || null
)

export const getHotelHasIsraeliVat = createSelector([getHotelData], hotel =>
  getHasILResidentVAT(hotel?.country, hotel?.navPathInfo?.city?.id)
)

export const getHasIsraeliAdditionalCharges = createSelector(
  [getHotelHasIsraeliVat, getIsIsraeliResident],
  (hotelHasIsraeliVat, isIsraeliResident) =>
    hotelHasIsraeliVat && !isIsraeliResident
)
